export default {
  ENCUESTADO_OPCION: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
